import "./SinglePostTemplate.module.css"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
